import httpClient, { handleAPIError, createSuccessResponse } from './httpClient.js';

/**
 * StatisticsAPI - Handles all statistics-related API operations
 *
 * Provides endpoints for fetching application statistics
 * and aggregated data for dashboard displays
 */
export class StatisticsAPI {
  constructor() {
    this.client = httpClient;
  }

  /**
   * Get summary statistics for the application
   * Includes total mines, status breakdowns, etc.
   *
   * @returns {Promise<Object>} Response with statistics data
   */
  async getStatistics() {
    try {
      const response = await this.client.get('/stats/summary');
      return createSuccessResponse(response.data, response.status);
    } catch (error) {
      return handleAPIError(error, { operation: 'getStatistics' });
    }
  }

  /**
   * Get statistics filtered by specific criteria
   * Future enhancement for filtered statistics
   *
   * @param {Object} filters - Filter criteria
   * @returns {Promise<Object>} Response with filtered statistics
   */
  async getFilteredStatistics(filters) {
    try {
      const response = await this.client.get('/stats/filtered', {
        params: filters
      });
      return createSuccessResponse(response.data, response.status);
    } catch (error) {
      return handleAPIError(error, { operation: 'getFilteredStatistics' });
    }
  }
}

// Export singleton instance
export const statisticsAPI = new StatisticsAPI();